export const onContentLoaded = (handler: () => void) => {
  if (['complete', 'loaded', 'interactive'].includes(document.readyState)) {
    handler()
  } else {
    document.addEventListener('DOMContentLoaded', handler)
  }
}

export const parentQuerySelector = (element: Element, selector: string): Element | undefined => {
  const collection = document.querySelectorAll(selector)

  for (const possibleParent of collection) {
    if (possibleParent.contains(element)) {
      return possibleParent
    }
  }
}
